export default "__VITE_ASSET__RD9QjNvU__"